import React, {
	Component,
	PropTypes
} from 'react';
import dvcTypeService from "SERVICES/bump/dvcTypeService";

import {
	Link
} from "react-router";
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
import bumpService from 'SERVICES/purifier/bump/bumpService'
import SearchInput from 'CONFIG/component/search/searchInput'
import Tip from 'CONFIG/component/tip'
import ModalDel from 'CONFIG/component/ModalDel'
import BoxHeader from "CONFIG/component/boxHeader"
import ContentHeader from 'CONFIG/component/contentHeaderLeft'
import {language,resultTip,pageOption} from 'UTIL/common'
import LongSearchInput from 'CONFIG/component/search/longSearchInput'
export default class DvctypeIndex extends Component {
	constructor(props) {
		super(props);
		this.handle = this.handle.bind(this);
		this.search = this.search.bind(this);
		this.delList = this.delList;
		this.del = this.del.bind(this);
		this.onPageChange = this.onPageChange.bind(this);
		this.state = {
			list: [],
			pageSize: 10,
			page: 1,
			total: 0,
			delRow: {},
		}
	};
	componentDidMount() {
        this.onPageChange(this.state.page,this.state.pageSize)
	}
	handle(cell, row) {
		const edit_url = "/config/dvctype/dvctypeEdit/"+ row.id;
		return (<div>
			<Link  to ={edit_url} className="btn btn-info btn-sm">{language()['edit']}</Link>&nbsp;&nbsp;
			<a  className="btn btn-danger btn-sm" data-target="#delModal" data-toggle="modal"
				onClick={this.delList.bind(this,row.id,row.metaName)}>{language()['delete']}</a>
		</div>);

	};
	delList(id, name, e) {
		const delList = {
			"id": id,
			"name": name
		};
		this.setState({
			delRow: delList,
		})
	}
	del() {
		var id = this.state.delRow.id;
        bumpService.dvcTypeDel(id).then(json => {
        	this.onPageChange(1,this.state.pageSize)
            resultTip(json)
        })
	}
	search() {
        this.onPageChange(1,this.state.pageSize);
	}
	onPageChange(page, sizePerPage, e) {
        var name = $("#name").val();
        var arr = {
            "page": page,
            "pageSize": sizePerPage,
            "search": name
        };
        var data = JSON.stringify(arr);
        bumpService.dvcTypeFetch({data}).then(json => {
        	console.log(json)
            this.setState({
                total: json.data.total,
                list: json.data.records,
				page:page,
				pageSize:sizePerPage,
            })}
        )
	}
    reset(){
        $("#name").val('');
        this.onPageChange(1,10)
    }
	render() {
    	let options= pageOption(this.state.page,this.state.pageSize);
    	options['onPageChange'] =this.onPageChange.bind(this);
		const create_url = "/config/dvctype/dvctypeCreate";
		return (
			<div >
				<section className="content-header " >
					<h1> {language()['BasicConfiguration']} <small>{language()['ModelCategory']}</small> </h1>
			            </section>
			             <section className="content" >
		             		<div className="box box-primary color-palette-box">
		                 			 <div className="box-header with-border">
		                   				 <i className="fa fa-list"></i>
										 <h3 className="box-title">{language()['ModelCategoryList']}</h3>
										 <div style={{marginRight:"10px",float:"right"}}>
											  <Link  to ={create_url} className="btn btn-success btn-md"  >
													<i className="fa fa-plus-circle"></i> {language()['add']}
											  </Link>
						            	</div>
		                  			</div>
		                  			<div className="box-body">
		                       				<Tip ids=""/>
											<div className="title-box">
												<div className="clearfix">
													<LongSearchInput id="name" name={language()['CategoryName']}/>
													<button type="button" className="btn btn-info" onClick={this.search.bind(this)}>{language()['query']}</button>
													&nbsp;&nbsp;
													<button type="button" className="btn btn-warning" id="reset" onClick={this.reset.bind(this)}>
                                                        {language()['resetting']}
													</button>
												</div>
											</div>
			                    			<div >
											<BootstrapTable data = {this.state.list}  remote={true} fetchInfo={{ dataTotalSize: this.state.total }}
															striped hover pagination={true} options={options}  >
												<TableHeaderColumn isKey dataField='id' hidden="true">ID </TableHeaderColumn>
												<TableHeaderColumn dataField='name' width="200"> {language()['CategoryName']} </TableHeaderColumn>
												<TableHeaderColumn  dataFormat={this.handle} width="300" columnClassName="td-mid">{language()['operation']}</TableHeaderColumn>
											</BootstrapTable>
		                  				</div>
		                  			</div>
		                		</div>
		             	</section>
				<ModalDel id="delModal" delModSure={this.del} />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./modules/bump/config/dvctype/dvctypeIndex.js